// Simple "clamp" utility function. Clamps a value between a minimum and maxiumum value.
const clamp = (value: number, min: number, max: number) =>
  Math.min(Math.max(value, min), max);

export default clamp;
